import { FormattedMessage } from "react-intl";
import LockIcon from "../../../components/Common/SvgIcons/SocialIcons/LockIcon";
import CopyIcon from "../../../components/Common/SvgIcons/TableIcons/CopyIcon";
import DistributeIcon from "../../../components/Common/SvgIcons/TableIcons/DistributeIcon";
import EditIcon from "../../../components/Common/SvgIcons/TableIcons/EditIcon";
import ResultIcon from "../../../components/Common/SvgIcons/TableIcons/ResultIcon";
import DownloadIcon from "../../../components/Common/SvgIcons/TableIcons/DownloadIcon"
import ViewIcon from "../../../components/Common/SvgIcons/TableIcons/ViewIcon";
import Tooltip from "../../../components/Common/ToolTip/Tooltip";
import { tableColumnTypes } from "../../tableColumnTypes";
import { social } from "./social";

export const pollManagement = {
  label: <FormattedMessage id="Poll_Management" />,
  // path: `${social.path}/pollManagement`,
  path: (tenantName) => `/${tenantName}/social/pollManagement`,
  searchPlaceHolder: "Search Poll By Name",
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: "Social Connect",
      path: `${social.path(tenantName)}`,
      onClick: () => navigate(`${social.path(tenantName)}`),
    },
    {
      key: 2,
      label: pollManagement.label,
      path: `${pollManagement.path(tenantName)}`,
      onClick: () => navigate(`${pollManagement.path(tenantName)}`),
    },
  ],
  columns: (
    handleEditModal,
    handleViewModal,
    handleCopyModal,
    handlePollResult,
    handleDistributeClick,
    handleDownloadPollResult
  ) => [
    {
      ID: 1,
      name: <FormattedMessage id="P_Polls" />,
      fieldName: "Name",
      value: (row) => (
        <div title={row?.Name}>
          {row?.Name?.length > 25 ? row?.Name?.slice(0, 23) + "..." : row?.Name}
        </div>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="Cer_Creator" />,
      fieldName: "CreatedBy",
      value: (row) => (row.CreatedBy ? row.CreatedBy : "By Me"),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: "Created Date",
      fieldName: "CreatedOn",
      value: (row) => {
        const createdDate = row?.CreatedOn?.split("T")?.[0].split("-");
        return (
          createdDate[2] +
          "/" +
          createdDate[1] +
          "/" +
          createdDate[0] +
          " " +
          row?.CreatedOn?.split("T")?.[1]
        );
      },
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 4,
      name: "No. of Votes",
      fieldName: "VotesCount",
      value: (row) => (
        <span style={{ color: !row.CreatedBy ? "green" : "red" }}>
          {row.VotesCount}
        </span>
      ),
      sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 5,
      name: <FormattedMessage id="BULKUPLD_ACTION" />,
      fieldName: "",
      value: (row) => (
        <div
          style={{
            display: "flex",
            gap: "1rem",
            alignItems: "center",
            justifyContent: "space-between",
            paddingRight: "1rem",
          }}
        >
          <span>
            {!row.CreatedBy && !row.IsLocked && (
              <span onClick={() => handleDistributeClick(row)}>
                <Tooltip direction="bottom" content={<FormattedMessage id="Distribute" />}>
                  <DistributeIcon />
                </Tooltip>
              </span>
            )}
            {!row.CreatedBy &&
              parseInt(row.VotesCount) === 0 &&
              !row.IsLocked && (
                <span onClick={() => handleEditModal(row)}>
                  <Tooltip direction="bottom" content={<FormattedMessage id="MYCLASS_EDIT" />}>
                    <EditIcon />
                  </Tooltip>
                </span>
              )}
            <span onClick={() => handleCopyModal(row)}>
              <Tooltip direction="bottom" content={<FormattedMessage id="EDIT_COPY" />}>
                <CopyIcon />
              </Tooltip>
            </span>
            <span onClick={() => handleViewModal(row)}>
              <Tooltip direction="bottom" content={<FormattedMessage id="P_REVIEW" />}>
                <ViewIcon />
              </Tooltip>
            </span>
            <span onClick={() => handlePollResult(row)}>
              <Tooltip direction="bottom" content={<FormattedMessage id="P_RESULT" />}>
                <ResultIcon />
              </Tooltip>
            </span>
            {parseInt(row.VotesCount) > 0 && (
                <span onClick={() => handleDownloadPollResult(row)}>
                  <Tooltip direction="bottom" content={"Download Poll Result"}>
                    <DownloadIcon />
                  </Tooltip>
                </span>
              )}
          </span>
          {(row.IsLocked || row.CreatedBy) && (
            <Tooltip direction="bottom" content="Locked">
              <LockIcon />
            </Tooltip>
          )}
        </div>
      ),
      sort: false,
    },
  ],
};
